import Layout from "../components/layout"

import React from "react"

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import CssBaseline from '@mui/material/CssBaseline';
import { Box, Container } from '@mui/system';

import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

import { ThemeProvider } from '@mui/material/styles';

import { createTheme} from '@mui/material/styles';

import Grid from '@mui/material/Grid';

import DraftsRoundedIcon from '@mui/icons-material/DraftsRounded';
import CallIcon from '@mui/icons-material/Call';
import PersonIcon from '@mui/icons-material/Person';
import ForumIcon from '@mui/icons-material/Forum';
import LocalPostOfficeRoundedIcon from '@mui/icons-material/LocalPostOfficeRounded';
import AlternateEmailRoundedIcon from '@mui/icons-material/AlternateEmailRounded';
import HearingDisabledRoundedIcon from '@mui/icons-material/HearingDisabledRounded';
import TranslateRoundedIcon from '@mui/icons-material/TranslateRounded';
import VideocamRoundedIcon from '@mui/icons-material/VideocamRounded';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#f5f5f5',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }));

const Item2 = styled(Paper)(({ theme }) => ({
  backgroundColor: '#f5f5f5',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'left',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

function handleClick(event) {
    event.preventDefault();
    console.info('You clicked a breadcrumb.');
  }

const breadcrumbs = [
    <Link underline="hover" key="1" color="inherit" href="/" onClick={handleClick}>
      Home
    </Link>,
   
    <Typography key="3" color="text.primary">
      Contact Us
    </Typography>,
  ];

const Page = ({ pageContext }) => {
    return(
        <Layout>
               <React.Fragment>
      <CssBaseline />
      <Container maxWidth="lg">

      <Stack spacing={2} >
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>

    <h1>{pageContext.body.title}</h1>

    <Typography variant="h6" gutterBottom>
        Administration
      </Typography>

      <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={3}>
        <Grid item xs="2.4">
          <Item>
          <AlternateEmailRoundedIcon/><br></br>
            <strong>Email us </strong><br></br>
            <a href="mailto:info@armadale.wa.gov.au">info@armadale.wa.gov.au</a><br></br>
            &nbsp;<br></br>
            &nbsp;<br></br>
            &nbsp;<br></br>
            &nbsp;<br></br>
            &nbsp;<br></br>
          </Item>
        </Grid>
        <Grid item xs="2.4">
          <Item>
          <CallIcon/> <br></br>
          <strong>Call us</strong><br></br>
            +61 8 9394 5000<br></br>
            <br></br>
            8.15am - 5pm AWST<br></br>
            Monday to Friday<br></br>
            excluding public holidays
            &nbsp;<br></br>
            &nbsp;<br></br>
        </Item>
        </Grid>
        <Grid item xs="2.4">
          <Item>
          <PersonIcon/><br></br>
          <strong>Visit us</strong><br></br>
          7 Orchard Avenue <br></br>
          Armadale<br></br>
          <br></br>
          8.15am - 5pm AWST<br></br>
            Monday to Friday<br></br>
            excluding public holidays
            </Item>
        </Grid>
        <Grid item xs="2.4">
          <Item>
          <ForumIcon/><br></br>
          <strong>Chat with us</strong><br></br>
          8.15am - 5pm AWST<br></br>
            Monday to Friday<br></br>
            excluding public holidays<br></br>
            &nbsp;<br></br>
            &nbsp;<br></br>
            &nbsp;<br></br>
            </Item>
        </Grid>
        <Grid item xs="2.4">
          <Item>
          <DraftsRoundedIcon/><br></br>
          <strong>Write to us</strong><br></br>
          Locked Bag 2<br></br>
          Armadale<br></br>
          Western Australia 6992<br></br>
          &nbsp;<br></br>
          &nbsp;<br></br>
          &nbsp;<br></br>
            </Item>   
        </Grid>
        <Grid item xs="2.4">
          <Item>
          <HearingDisabledRoundedIcon/><br></br>
          <strong>NRS</strong><br></br>
          <a href="https://www.accesshub.gov.au/about-the-nrs">www.accesshub.gov.au/about-the-nrs</a><br></br>
          &nbsp;<br></br>
          &nbsp;<br></br>
          &nbsp;<br></br>
            </Item>   
        </Grid>
        <Grid item xs="2.4">
          <Item>
          <TranslateRoundedIcon/><br></br>
          <strong>TIS National</strong><br></br>
          <a href="https://www.tisnational.gov.au">www.tisnational.gov.au</a><br></br>
          &nbsp;<br></br>
          &nbsp;<br></br>
          &nbsp;<br></br>
          &nbsp;<br></br>
            </Item>   
        </Grid>
        <Grid item xs="2.4">
          <Item>
          <VideocamRoundedIcon/><br></br>
          <strong>Media</strong><br></br>
          <a href="mailto:media@armadale.wa.gov.au">media@armadale.wa.gov.au</a><br></br>
          &nbsp;<br></br>
          &nbsp;<br></br>
          &nbsp;<br></br>
          &nbsp;<br></br>
            </Item>   
        </Grid>
      </Grid>
    </Box>

   
    <Box sx={{ flexGrow: 1, mt: 8, mb: 8 }}>
    <Grid container spacing={2} columns={16}>
    <Grid item xs={8}>
    <Typography variant="h6" gutterBottom>
        Facilities
      </Typography>
      </Grid>
      <Grid item xs={8}>
      
      </Grid>
      <Grid item xs={8}>
      <Item2><strong>Animal Management Facility</strong></Item2>
      </Grid>
      <Grid item xs={8}>
      <Item2><a href="https://www.armadale.wa.gov.au/animal-management-facility-lost-animals">www.armadale.wa.gov.au/animal-management-facility-lost-animals</a></Item2>
     </Grid>
     <Grid item xs={8}>
      <Item2><strong>Armadale Fitness and Aquatic Centre</strong></Item2>
      </Grid>
      <Grid item xs={8}>
      <Item2><a href="https://active.armadale.wa.gov.au/">www.active.armadale.wa.gov.au</a></Item2>
     </Grid>
     <Grid item xs={8}>
      <Item2><strong>Libraries</strong></Item2>
      </Grid>
      <Grid item xs={8}>
      <Item2><a href="https://library.armadale.wa.gov.au/">www.library.armadale.wa.gov.au</a></Item2>
     </Grid>
     <Grid item xs={8}>
      <Item2><strong>Museums</strong></Item2>
      </Grid>
      <Grid item xs={8}>
      <Item2><a href="https://www.armadale.wa.gov.au/museums">www.armadale.wa.gov.au/museums</a></Item2>
     </Grid>
     <Grid item xs={8}>
      <Item2><strong>Perth Hills Armadale Visitor Centre</strong></Item2>
      </Grid>
      <Grid item xs={8}>
      <Item2><a href="https://www.perthhillsarmadale.com.au/">www.perthhillsarmadale.com.au</a></Item2>
     </Grid>
     <Grid item xs={8}>
      <Item2><strong>Waste disposal and recycling centres</strong></Item2>
      </Grid>
      <Grid item xs={8}>
      <Item2><a href="https://www.armadale.wa.gov.au/waste-disposal-and-recycling-centres">www.armadale.wa.gov.au/waste-disposal-and-recycling-centres</a></Item2>
     </Grid>
  </Grid>
</Box>
      </Container>
    </React.Fragment>
</Layout>
      );
    }
      function AddPageImage(prop) {
        const obj = prop.pgCxt;
        if ( obj.body.pageImage ) {    
                
          if ( obj.body.pageImage.file.fileName == "PHA.mp4" ) {
            return <video src={obj.body.pageImage.file.url} loop muted autoPlay class="fullVideo"></video>;
          } else {        
            return <img src={obj.body.pageImage.file.url} />;
          }
          
        }
      }
      
      export default Page